// extracted by mini-css-extract-plugin
export default {"wrapper":"rxYi45A0UFYZJtxhc4uw"};